import { media } from 'styled-bootstrap-grid'
import styled from 'styled-components'
import { Mode } from '@ocean/types/dist/appearance'

type RootProps = {
  mode?: Mode
}

export const Root = styled.div<RootProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;

  ${({ theme, mode }) => {
    const isDarkMode = mode === Mode.Dark

    return `
      padding-top: calc(${theme.space.mobile.base} * 2);
      padding-bottom: ${theme.space.mobile.large};
      background-color: ${isDarkMode ? 'transparent' : theme.color.white};
      color: ${isDarkMode ? theme.color.white : theme.color.black};
    `
  }}

  ${({ theme }) => media.sm`
    padding: ${theme.space.desktop.large} 0;
  `}
`

export const TopSegment = styled.div`
  ${({ theme }) => `
    margin-bottom: calc(${theme.space.mobile.large} + ${theme.space.mobile.nano});
    height: ${theme.space.mobile.base};
  `}

  ${({ theme }) => media.sm` 
    margin-bottom: ${theme.space.desktop.large};
    height: ${theme.space.desktop.small};
  `}
`

export const Title = styled.div`
  div[data-selector='SectionTitle'] {
    margin-bottom: 0;
  }
`

export const Content = styled.div`
  ${({ theme }) => `
    margin-top: ${theme.space.mobile.large};
  `}

  ${({ theme }) => media.sm` 
    margin-top: ${theme.space.desktop.tiny};
  `}

  div[data-selector='Search'] {
    ${({ theme }) => `
      margin-top: ${theme.space.mobile.base};
    `}

    ${({ theme }) => media.sm` 
      margin-top: ${theme.space.desktop.large};
    `}
  }
`
